import { Injectable } from '@angular/core';
import { Observable, throwError, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

import { AttivitaReale } from '../models/didattica/attivita-reale';
import { Idoneita } from '../models/idoneita/idoneita';
import { Docente } from '../models/didattica/docente';
import { IdoneitaStudente } from '../models/idoneita/Idoneita-studente';
import { IdoneitaModuloInteg } from '../models/idoneita/Idoneita-modulo-integ';
import { StudenteEnanche } from '../models/didattica/studente-enanche';
import { UtilityService } from './utility.service';
import { ConfigService } from './config-service/config-service';
import { ChiaveConfig } from '../models/configurazioni/ChiaveConfig';
import { DidatticaService } from './didattica-service';
import { Presenza } from '../models/rilevazione-presenze/presenza';
import { RilevazionePresenzeService } from './rilevazione-presenze-service';
import { RecuperoService } from './recupero-service';
import { Recupero } from '../models/recupero';
import { Studente } from '../models/didattica/studente';
import { UserService } from './user-service';
import { Corso } from '../models/didattica/corso';
import { OreTipoAttivita } from '../models/didattica/ore-tipo-attivita';

/**
 * Fornisce i servizi relativi all'invio dell'idoneità di frequenza'
 */
@Injectable( { providedIn: 'root' })
export class IdoneitaService {

  optionsContJson = {headers: new HttpHeaders({'Content-Type':  'application/json'})};
  accorpaModuliDocenti: boolean;

  constructor(public http: HttpClient,
    private utilityService: UtilityService,
    private didatticaService: DidatticaService,
    private rilevazionePresenzeService: RilevazionePresenzeService,
    private recuperoService: RecuperoService,
    private userService: UserService,
    protected configService: ConfigService
    ) {
    console.log('Hello IdoneitaService Provider');
    this.accorpaModuliDocenti = this.configService.getConfigurazione(ChiaveConfig.ACCORPA_MODULI_DOCENTI) === 'true';
  }

  sendIdoneita(idoneita: Idoneita) {
    const post = {
      'id': idoneita ? idoneita.id : null  };

  return this.http.put('idoneita/invia', JSON.stringify(post), this.optionsContJson).pipe(
    map(r => this.parseIdoneitaResponse(r))
    );
  }

  recuperIdoneitaInvii(anno: string, docente: Docente, corso: Corso, geolocstatus: number): Observable<Idoneita[]> {

    let idDocente = '';
    if (docente) {
      idDocente = docente.id;
    }
    let idCorso = '';
    if (corso) {
      idCorso = corso.id;
    }

    const url = `idoneita/get/${anno}?docente=${idDocente}&corso=${idCorso}&glstatus=${geolocstatus}`;

    return this.http.get(url)
      .pipe(map(r => this.parseIdoneitasResponse(r)),
      catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(error);
        }
      }));
  }

  cercaRichiesetBloccoCancellazione(idoneita: Idoneita): Observable<IdoneitaStudente[]> {

    const url = `idoneita/get/studenti/blockedgeoloc/${idoneita.id}`;

    return this.http.get(url)
      .pipe(map(r => this.parseIdoneitaStudentiResponse(r)),
      catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(error);
        }
      }));
  }

  deleteInfoGeolocalizzazione(idIdo: string): Observable<any> {
    // return this.http.delete(`deleghe/${delega.id}`,  this.optionsContJson)
    //   .pipe(map(r => { }));
      return this.http.delete<string>(`idoneita/geolocalizzazioni/${idIdo}`,  this.optionsContJson)
      .pipe(map(r => parseInt(r, 10)));
  }

  deleteAllInfoGeolocalizzazione(anno: string, docente: Docente, corso: Corso, geolocstatus: number): Observable<Idoneita[]> {
    let idDocente = '';
    if (docente) {
      idDocente = docente.id;
    }
    let idCorso = '';
    if (corso) {
      idCorso = corso.id;
    }
    const url = `idoneita/geolocalizzazioni/all/${anno}?docente=${idDocente}&corso=${idCorso}&glstatus=${geolocstatus}`;
      return this.http.delete<Idoneita[]>(url, this.optionsContJson)
      .pipe(map(r => this.parseIdoneitasResponse(r)));
  }


  getTestataIdoneita(ar: AttivitaReale, doc: Docente): Observable<Idoneita> {
    let url = '';
    // si tratta di un insegnamento semplice
    url = `idoneita/get/${ar.id.split(':')[1]}/${ar.id.split(':')[0]}/${ar.annoAccademico}/${doc.id}`;
    // si tratta di un integrato
    if ( ar.afGenIntegCod ) {
      url += `/${ar.afGenIntegCod}`;
    }
    if (Number(ar.annoAccademico) >= 2025 && ar.moduloMonoDisc ) {
      url += `/${ar.afGenCod}`;
    }

    return this.http.get(url)
      .pipe(map(r => this.parseIdoneitaResponse(r)),
      catchError(error => {
        if (error.status === 404) {
          return of(undefined);
        } else {
          throwError(error);
        }
      }));
  }

  public addUpdIdoneita(idoneita: Idoneita, ar: AttivitaReale, doc: Docente, limiteIdoneita: number): Observable<Idoneita> {

    // Number(ar.annoAccademico) >= 2025 
    // dovuto alla fix per il corretto recupero dei monodisciplinari non applicabile alle
    //  idoneità inviate negli anni precedenti al 2025

    let post;
    if (idoneita) {
      idoneita.frequenzaDoc = limiteIdoneita;
      post = idoneita;
    } else {
      post = {
          'id': null,
          'annoAccademico': ar.annoAccademico,
          'idDocente': doc.id,
          'idAttivitaReale': ar.id,
          'integCod': ar.afGenIntegCod? ar.afGenIntegCod : ar.moduloMonoDisc && Number(ar.annoAccademico) >= 2025? ar.afGenCod: null,
          'frequenzaObblig': ar.freqObbligFlg,
          'oreMinFreq': ar.oreMinFreq,
          'percOreFreq': ar.percOreFreq,
          'frequenzaDoc': limiteIdoneita
      };
    }
    const json =  JSON.stringify(post);
    console.log('json', json);
    return this.http.put('idoneita', json, this.optionsContJson).pipe(
      map(r => this.parseIdoneitaResponse(r)));
  }

  getIdoneitaModuliInteg(idoneita: Idoneita):  Observable<IdoneitaModuloInteg[]> {
    const url = `idoneita/get/moduli/${idoneita.id}`;
    return this.http.get(url)
      .pipe(map(r => this.parseIdoneitaModuliIntegResponse(r)));
  }

  addUpdIdoneitaModuliInteg(idoneita: Idoneita, doc: Docente, moduliInteg: AttivitaReale[]) {
    const moduli = [];
    for (const m of moduliInteg) {
      const modulo = {
        'id': m.idIdoneita ? m.idIdoneita : null,
        'idIdoneita': idoneita.id,
        'idAttivitaRealeMod': m.id,
        'annoAccademicoMod': m.annoAccademico,
        'idDocenteMod': m.docente.id
      };
      moduli.push(modulo);
    }
    const body = { idoneitaModuliInteg: moduli };
    return this.http.put('idoneita/moduliinteg', body, this.optionsContJson).pipe(
      map(r => this.parseIdoneitaModuliIntegResponse(r)));
  }

  negaGeolocCleaning(idoneitaSudente: IdoneitaStudente): Observable<IdoneitaStudente> {
    return this.http.post<IdoneitaStudente>(`idoneita/ist/${idoneitaSudente.id}/denygeolocclean`,  this.optionsContJson)
      .pipe(map(r => this.parseIdoneitaStudentiResponse(r).pop()));
  }

  getIdoneitaStudenti(idoneita: Idoneita):  Observable<IdoneitaStudente[]> {
    const url = `idoneita/get/studenti/${idoneita.id}`;
    return this.http.get(url)
      .pipe(map(r => this.parseIdoneitaStudentiResponse(r)));
  }

  countIdoneitaInviateStudente(studente: Studente): Observable<number> {
    const url = `idoneita/count/studente/${studente.id}`;
    return this.http.get<string>(url)
    .pipe(map(r => parseInt(r, 10)));
  }

  addUpdIdoneitaStudenti(idoneita: Idoneita, idoneitaStudenti: IdoneitaStudente[], studenti: StudenteEnanche[])
                                                                                            :  Observable<IdoneitaStudente[]> {

    // carica eventuali recuperi frquenze richiesti per i moduli

    // studenti.push( { studente: stud ,
    //   freqinfo: { npres: nStudPres, totpres: studTotPres,
    //            // idoneita (boolean) e idoneitadoc (number nullable) andranno recuperai dal db
    //            frequenza: frequenza , assenza: 1 - frequenza, idoneita: false , idoneitadoc: undefined } ,
    const localIdoneitaStudenti = [];

    for (const s of studenti) {

      if (idoneitaStudenti && idoneitaStudenti.length > 0) {
        // cerca l'idoneità studente e l'aggiorna
        const idoneitaStudente = idoneitaStudenti[idoneitaStudenti.findIndex((idost) =>  idost.idStudente === s.studente.id )];

        if (idoneitaStudente) {
          idoneitaStudente.idoneo = s.freqinfo.idoneita;
          idoneitaStudente.idoneoDocente = s.freqinfo.idoneitadoc;
          idoneitaStudente.frequenza = s.freqinfo.frequenza;
          idoneitaStudente.libretto = s.freqinfo.libretto;
          idoneitaStudente.idIdoneita = idoneita.id;
          idoneitaStudente.frequenzaDoc = idoneita.frequenzaDoc;
        } else {
          idoneitaStudenti.push(this.genIdoneitaStudente(idoneita, s));
        }

      } else {

        const idoneitaStudente = this.genIdoneitaStudente(idoneita, s);
        localIdoneitaStudenti.push(idoneitaStudente);
      }
    }

    const body = { idoneitaStudenti: idoneitaStudenti && idoneitaStudenti.length > 0 ? idoneitaStudenti : localIdoneitaStudenti };
    return this.http.put('idoneita/studenti', body, this.optionsContJson).pipe(
      map(r => this.parseIdoneitaStudentiResponse(r)));

  }

  synchStudentiIdoneitaStudenti(idoneita: Idoneita, idoneitaStudenti: IdoneitaStudente[], studenti: StudenteEnanche[]): Observable<any> {
    const idoneitaStudentiToRemove: IdoneitaStudente[] = [];

      idoneitaStudenti.forEach((idoneitaStudente, i) => {
        let keep = false;
        studenti.forEach(studente => {
          if (idoneitaStudente.idStudente === studente.studente.id ) {
            keep = true;
          }
        });
        if (!keep) {
          idoneitaStudenti.splice(i, 1);
          idoneitaStudentiToRemove.push(idoneitaStudente);
        }
       });

       const body = { idoneitaStudenti: idoneitaStudentiToRemove };

       if (idoneitaStudentiToRemove.length === 0) {
        return of(idoneitaStudenti);
       }

       return this.http.post(`idoneita/studenti/remove`, body, this.optionsContJson )
        .pipe(map(r => idoneitaStudenti ));
    }


  genIdoneitaStudente(idoneita: Idoneita, s: StudenteEnanche): IdoneitaStudente {
    const idoneitaStudente: IdoneitaStudente = {
      'id': null,
      'idIdoneita': idoneita.id,
      'idStudente': s.studente.id,
      'matricola': s.studente.matricola,
      'idoneo': s.freqinfo.idoneita,
      'idoneoDocente': s.freqinfo.idoneitadoc,
      'libretto': s.freqinfo.libretto,
      'frequenza': s.freqinfo.frequenza,
      'frequenzaDoc': idoneita.frequenzaDoc
    };
    return idoneitaStudente;
  }

  // --------------------------------------------------------------

  private parseIdoneitasResponse(response: any): Idoneita[] {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const json = response; // .json();
      const data: Idoneita[] = (Array.isArray(json)) ? json : Array.of(json);
      this.toIdoneitasSmart(data);
      return data;
    }
  }

  private parseIdoneitaResponse(response: any): Idoneita {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const data: Idoneita = response;
      return data;
    }
  }

  public toIdoneitasSmart(idoneitas: Idoneita[]) {
    for (const ido of idoneitas) {
      this.toIdoneitaSmart(ido);
    }
  }

  public async toIdoneitaSmart(ido: Idoneita) {
    if (ido.ar) {
      this.didatticaService.toArSmart(ido.ar);
      if (ido.ar.afGenIntegCod) {
        // ido.ar.moduliInteg = await this.groupIntegAr(ido.ar.moduliInteg);
        for (const modulo of ido.ar.moduliInteg) {
          this.didatticaService.toArSmart(modulo);
        }

        if (this.accorpaModuliDocenti) {
          if (ido.ar.moduliInteg?.length > 0) {
            const arlist: AttivitaReale[] = [];
            arlist.push(ido.ar);
            this.accorpaModuli(arlist);
            ido.ar = arlist[0];
          }
        }


      }
    }
  }

  private parseIdoneitaStudentiResponse(response: any): IdoneitaStudente[] {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const json = response; // .json();
      const data: IdoneitaStudente[] = (Array.isArray(json)) ? json : Array.of(json);
      // console.log('idoneitaStudenti', data);
      return data;
    }
  }


  private parseIdoneitaModuliIntegResponse(response: any): IdoneitaModuloInteg[] {
    if (response instanceof HttpErrorResponse) {
      throw response;
    } else {
      const json = response; // .json();
      const data: IdoneitaModuloInteg[] = (Array.isArray(json)) ? json : Array.of(json);
      console.log('parseIdoneitaModuliIntegResponse', data);
      return data;
    }
  }

    // ------ UTILITY -----------------------------------------------

    // definePercentualeLezioni(ar: AttivitaReale) {
    //   let sommaPerc = 0;
    //   let percInteg = 0;

    //   if (ar.moduliInteg.length > 0) {
    //     ar.moduliInteg.forEach(function (modulo) {
    //       if (modulo.totaleMinuti / 60 >= modulo.ore) {
    //         percInteg = modulo.ore / ar.ore;
    //       } else {
    //         percInteg = modulo.totaleMinuti / 60 / ar.ore;
    //       }
    //       sommaPerc += percInteg;
    //     });
    //   }

    //   ar.percentualeLezioni = function () {
    //     return sommaPerc;
    //   };

    // }

    async elaboraPresenzeInteg(attivitaReali: AttivitaReale[]): Promise<boolean> {
      // viene in realtà richiamata anche per elaborare le presenze degli insegnamenti non integrati
      for (const ar of attivitaReali) {
        ar.studenti = this.parseStudentiFromPresenze(ar, false, true);
        if (ar.moduliInteg) {
          ar.presenze = [];
          await this.recuperaPresenzeARInteg(ar);
          ar.studenti = this.parseStudentiFromPresenze(ar, false, true);
          console.log('elaboraPresenzeInteg ar.studenti', ar.studenti);
        }
      }
      console.log('elaboraPresenzeInteg end');
      return of(true).toPromise();
    }

    // prepara l'array delle attività reali generando le testate degli integrati e popolando l'array di moduli
    groupIntegAr(attivitaReali: AttivitaReale[]): Promise<AttivitaReale[]> {

          let integCod: string = null ;
          let cdsCod: string = null ;
          let tipoCicloCod: string = null ;
          let partStuDes: string = null ;
          let sede: string = null ;
          const attivitaRealiInteg: AttivitaReale[] = [];
          let currentar: AttivitaReale;
          for (const ar of attivitaReali) {
              console.log('attivitaReale ', ar);
              // con una rottura di codice genera le testate degli integrati e popola i moduli
              if (ar.afGenIntegCod !== integCod || ar.partStuDes !== partStuDes || ar.sede !== sede
                || ar.cds[0].codice !== cdsCod || ar.tipoCicloCod !== tipoCicloCod
               ) {

                // testata dell'integrato
                const arcloned = { ...ar };
                const moduliInteg: Array<AttivitaReale> = [];
                arcloned.moduliInteg = moduliInteg;
                arcloned.ore = 0;
                arcloned.durataInMinuti = 0;
                arcloned.numeroRilevazioni = 0;
                arcloned.totaleMinuti = 0;
                arcloned.suddivisioneOre = [];
                attivitaRealiInteg.push(arcloned);

                integCod = ar.afGenIntegCod;
                partStuDes = ar.partStuDes;
                sede = ar.sede;
                tipoCicloCod = ar.tipoCicloCod;
                cdsCod = ar.cds[0].codice;
                currentar = arcloned;
              }
            currentar.atLeastOneGeolocPres = currentar.atLeastOneGeolocPres || ar.atLeastOneGeolocPres;
            currentar.moduliInteg.push(ar);
            currentar.ore += ar.ore ? ar.ore : 0;
            currentar.durataInMinuti += ar.durataInMinuti ? ar.durataInMinuti : 0;
            currentar.numeroRilevazioni += ar.numeroRilevazioni ? ar.numeroRilevazioni : 0;
            currentar.totaleMinuti += ar.totaleMinuti ? ar.totaleMinuti : 0;
            if (ar.suddivisioneOre) {
              currentar.suddivisioneOre = this.utilityService.mergeSuddivisioni(currentar.suddivisioneOre, ar.suddivisioneOre);
            }
            currentar.totaleMinutiF = this.utilityService.formatDurata(currentar.totaleMinuti);
            this.didatticaService.definePercentualeLezioni(currentar);
            this.redefineFrequenzaStudente(currentar);

          }

          const accorpaModuliDocenti = this.configService.getConfigurazione(ChiaveConfig.ACCORPA_MODULI_DOCENTI) === 'true';
          if (accorpaModuliDocenti) {
            if (attivitaRealiInteg.length > 0) {
              this.accorpaModuli(attivitaRealiInteg);
            }
          }

          return of(attivitaRealiInteg).toPromise();
      }

      redefineFrequenzaStudente(ar: AttivitaReale) {
        let sommaPerc = 0;
        let percInteg = 0;
        let evalSingleModulesHours = 'true' === this.configService.getConfigurazione(ChiaveConfig.EVAL_SINGLE_MODULE_HOURS);
        if (ar.durataInMinuti > 0 && ar.moduliInteg.length > 0) {
          ar.durataInMinuti = 0;
          ar.moduliInteg.forEach(function (modulo) {
            if (evalSingleModulesHours && modulo.durataInMinuti / 60 >= modulo.ore) {
              percInteg = (modulo.ore * 60) / ar.totaleMinuti;
            } else {
              percInteg = modulo.durataInMinuti / ar.totaleMinuti;
            }
            ar.durataInMinuti += modulo.durataInMinuti;
            sommaPerc += percInteg;
          });
          sommaPerc = Math.round(100*sommaPerc)/100;
        }
        if (!evalSingleModulesHours && sommaPerc>1) {
          sommaPerc = 1;
        }
        ar.frequenzaStudente = function () {
          return sommaPerc;
        };
      }

    accorpaModuli(attivitaReali: AttivitaReale[]) {
        for (const ar of attivitaReali) {
          if (ar.moduliInteg.length > 1) {
            const moduliIntegAccorpati: Array<AttivitaReale> = [];
            let udLogId = null;
            let afGenCod = null;
                    // rottura di codice per accorpare i moduli
            // se l'ud_log_id non cambia in Esse3 solo il docente è cambiato e il modulo
            // va considerato unico ai fini dell'invio
            for (const modulo of ar.moduliInteg) {
              if (afGenCod !== modulo.afGenCod || udLogId !== modulo.udLogId) {
                udLogId = modulo.udLogId;
                afGenCod = modulo.afGenCod;
                const moduloCloned = {...modulo};
                moduliIntegAccorpati.push(moduloCloned);
              } else {
                // accorpo i due moduli
                let prevModulo = moduliIntegAccorpati[moduliIntegAccorpati.length - 1];
                prevModulo = this.mergeModuli(prevModulo, modulo);
              }
            }
            if (moduliIntegAccorpati.length !== ar.moduliInteg.length) {
              // se c'è stato un accorpamento dei moduli entra qui e conserva i moduli originali
              // in un array che l'ar viewer utilizzerà per recuperare le presenze
              ar.moduliIntegNonAccorp = ar.moduliInteg;
              for (let modulo of moduliIntegAccorpati) {
                modulo = this.didatticaService.toArSmart(modulo);
              }
              ar.moduliInteg = moduliIntegAccorpati;
              this.didatticaService.definePercentualeLezioni(ar);
            }
          }
        }
      }

    mergeModuli(mod1: AttivitaReale, mod2: AttivitaReale): AttivitaReale {

        if (!mod1.docentiModuli) {
          mod1.docentiModuli = [];
          mod1.docente.moduloInteg = {...mod1};
          mod1.docentiModuli.push(mod1.docente);
          mod1.docente = undefined;
        }

        if (!mod1.rilevazioni) {
          mod1.rilevazioni = [];
        }
        mod1.rilevazioni = mod2.rilevazioni ? mod1.rilevazioni.concat(mod2.rilevazioni) : mod1.rilevazioni;

        if (mod1.oreIntegStud) { // se è popolato questo dato è quello da prendere
                                 // in considerazione come totale del modulo accorpato
          mod1.ore = mod1.oreIntegStud;
        } else {
          mod1.ore += mod2.ore ? mod2.ore : 0;
        }
        mod1.totaleMinuti += mod2.totaleMinuti ? mod2.totaleMinuti : 0;
        mod1.totaleMinutiF = this.utilityService.formatDurata(mod1.totaleMinuti);

        mod2.docente.moduloInteg = mod2;
        mod1.docentiModuli.push(mod2.docente);
        return mod1;
      }

    async recuperaPresenzeARInteg(ar: AttivitaReale): Promise<boolean> {
        console.log('recuperaPresenzeARInteg' , ar);
        // loop sugli integrati per recuperare tutte le presenze
        // potrebbero essere stati accorpati ma per il recupero delle presenze deve utilizzare gli originali
        ar.durataInMinuti = 0;
        const moduli = ar.moduliIntegNonAccorp ? ar.moduliIntegNonAccorp : ar.moduliInteg;
        for (const modulo of moduli) {
          const pres = await this.getPresenzeModulo(modulo);
          // salva le presenze per ogni singolo modulo
          modulo.presenze = pres;
          if (ar.presenze) {
            ar.presenze = ar.presenze.concat(pres);
          } else {
            ar.presenze = pres;
          }
          ar.durataInMinuti += modulo.durataInMinuti;
          
          // vengono recuperate anche eventuali convalide
          modulo.convalide = await this.getConvalide(modulo);
          console.log('modulo.convalide', modulo.convalide);

        }
        // se moduliIntegNonAccorp è popolato vuol dire che, a seguito dell'accorpamento,
        //  c'è stato un backup in questo array dei moduli originali
        if (ar.moduliIntegNonAccorp) {
          this.accorpaPresenze(ar);
        }
        console.log('recuperaPresenzeARInteg presenze recuperate', ar);
        return of(true).toPromise();
    }

    getConvalide (ar: AttivitaReale): Promise<Recupero[]> {
      return  this.recuperoService.getConvalide(ar).toPromise();
    }

    getPresenzeModulo (ar: AttivitaReale): Promise<Presenza[]> {
        console.log('getPresenzeModulo', ar);
        if (ar.presenze) {
          return of(ar.presenze).toPromise();
        }
        return this.rilevazionePresenzeService.getPresenzeAR(ar).toPromise();
    }

    // potrebbe essere necessario raggruppare anche le convalide ...verificare
    accorpaPresenze(ar: AttivitaReale) { 
        const localModuliInteg: Array<AttivitaReale> = [];
        for (const modulo of ar.moduliInteg) {
          const moduliOriginali = ar.moduliIntegNonAccorp.filter(modulo_ => {
            return (modulo_.afGenCod === modulo.afGenCod && modulo_.udLogId === modulo.udLogId);
          });
          let presenzeModuli: Array<Presenza> = [];
          let convalideModuli: Array<Recupero> = [];
          for (const moduloOriginale of moduliOriginali) {
            console.log('moduloOriginale.presenze', moduloOriginale.presenze);
            presenzeModuli = presenzeModuli.concat(moduloOriginale.presenze);
            convalideModuli = convalideModuli.concat(moduloOriginale.convalide);
          }
          modulo.presenze = presenzeModuli;
          modulo.convalide = convalideModuli;
          localModuliInteg.push(modulo);
        }
        ar.moduliInteg = localModuliInteg;
      }

      parseStudentiFromPresenze(ar: AttivitaReale, usaOreAD: boolean, useCurrentStudent?: boolean): StudenteEnanche[] {
        console.log('parseStudentiFromPresenze ar start');
        const studenti = this.rilevazionePresenzeService.parsePresenze(ar, usaOreAD);
        const abilitaRecuperi = 'true' === this.configService.getConfigurazione(ChiaveConfig.ABILITA_RECUPERI);
        if (!abilitaRecuperi) {
          if (ar.moduliInteg ) {
            // parsing delle presenze degli  eventuali moduli
            for (const modulo of ar.moduliInteg ) {
              modulo.studenti = this.rilevazionePresenzeService.parsePresenze(modulo, usaOreAD);
            }
          }
        } else {

          let currentStud: Studente;
          if (useCurrentStudent) {
            currentStud = this.userService.getStudenteCorrente();
            // l'array è vuoto se l'AR non ha (ancora) presenze, es. testata dell'integrato
            // prima di recuperaPresenzeARInteg
            if (studenti.length > 0) {
              studenti[0].studente = currentStud;
            }
          }
          console.log('parseStudentiFromPresenze studenti ar integ', studenti);
          // this.nstudenti = this.studenti.length;
          if (ar.moduliInteg) {
            const studsConvalidati: Studente[] = [];
            // parsing delle presenze degli  eventuali moduli
            for (const modulo of ar.moduliInteg) {
              modulo.studenti = this.rilevazionePresenzeService.parsePresenze(modulo, usaOreAD);

              if (modulo.studenti && modulo.studenti.length === 1 && useCurrentStudent) {
                modulo.studenti[0].studente = currentStud;
              }

              if (modulo.convalide && modulo.convalide.length > 0) {
                for (const convalida of modulo.convalide) {

                  // se non è presente nell'elenco di studenti con una convalida lo aggiunge
                  const studConv = studsConvalidati.filter(studente => {
                    return convalida.idStudente === studente.id;
                  });
                  if (studConv && !studConv[0]) {
                    studsConvalidati.push(convalida.studente);
                  }

                  convalida.freqInfo.insefrequenza = convalida.insegnamentoFrequenza;
                  convalida.freqInfo.insefrequenza.docente = convalida.docenteFrequenza;

                  if (modulo.studenti && modulo.studenti.length > 0) {
                    const stud = modulo.studenti.filter(studente => {
                      return convalida.idStudente === studente.studente.id;
                    });
                    if (stud && stud.length === 1) { // se c'è già aggiorna le frequinfo
                      stud[0].freqinfo = convalida.freqInfo;
                    } else {
                      // aggiunge lo stud
                      const stu: StudenteEnanche = {
                        studente: convalida.studente,
                        freqinfo: convalida.freqInfo,
                        presenze: []
                      };
                      modulo.studenti.push(stu);
                    }
                  } else {
                    if (convalida.idStudente === currentStud.id) {
                      const stu: StudenteEnanche = {
                        studente: convalida.studente,
                        freqinfo: convalida.freqInfo,
                        presenze: []
                      };
                      modulo.studenti.push(stu);
                    }
                  }
                }
              }
              console.log('parseStudentiFromPresenze modulo', modulo);
              console.log('parseStudentiFromPresenze studenti modulo', modulo.studenti);
              }

            if (studsConvalidati.length > 0 ) {

                // è necessario ricalcolare il frequinfo per gli studenti con delle convalide
                // le presenze potrebbero non essere necessarie, magari lo saranno in fase di invio e
                // le recuperermo dal modulo convalidato
                for (const stuConConvalida of studsConvalidati) {

                  const studar = studenti.filter(studente => {
                    return stuConConvalida.id === studente.studente.id;
                  });
                  if (studar && studar[0]) {
                    console.log('stud da ricalcolare', studar[0]);
                    // ricalcolare studar[0].freqinfo in base ai moduli
                    studar[0].freqinfo.frequenza = 0;
                    studar[0].freqinfo.assenza = 0;
                    studar[0].freqinfo.npres = 0;
                    studar[0].freqinfo.totpres = 0;
                    studar[0].presenze = [];
                  }

                  if (ar.moduliInteg ) {
                    for (const modulo of ar.moduliInteg ) {
                      const studm = modulo.studenti.filter(studente => {
                        return stuConConvalida.id === studente.studente.id;
                      });
                      if (studm && studm[0]) {
                        if (useCurrentStudent) {
                          modulo.durataInMinuti = studm[0].freqinfo.totpres;
                        } else {
                          if (studar && studar[0]) {
                            studar[0].freqinfo.npres += studm[0].freqinfo.npres;
                            studar[0].presenze =  studar[0].presenze.concat(studm[0].presenze);
                            studar[0].freqinfo.totpres += studm[0].freqinfo.totpres;
                          }
                        }
                      }
                    }
                  }
                  if (useCurrentStudent) {
                    this.redefineFrequenzaStudente(ar);
                  } else {
                    if (studar && studar[0]) {
                      studar[0].freqinfo.frequenza = (studar[0].freqinfo.totpres / (ar.ore * 60));
                      console.log('studar[0].freqinfo.frequenza', studar[0].freqinfo.frequenza);
                    }
                  }
              }
            }
          }
        }
        console.log('parseStudentiFromPresenze studenti', studenti);
        console.log('parseStudentiFromPresenze ar end', ar);
        return studenti;

      }

}
